<div class="accordion-group">
    <ng-content></ng-content>
    <div class="clear"></div>
</div>
